// This only asks for review; it never decides where to split a product. Commas
// in strengths and parenthesized ingredients are not evidence of a list.
export const looksLikeMedicationList = (text = "") =>
  text
    .replace(/\([^)]*\)|\[[^\]]*\]/g, "")
    .replace(/(\d),(?=\d)/g, "$1")
    .split(/[,;\r\n•]+/)
    .filter((part) => /[a-z]/i.test(part)).length > 1;

// The rows of a /visits/medications/preview result the patient can review as
// separate medications, or null when extraction failed, was partial or left a
// row still grouped: a partial extraction must not become an apparently
// complete list, so the original text is kept instead.
export const reviewableMedicationRows = (result) => {
  const entries = result?.entries;
  if (
    !result ||
    result.manualEntry ||
    result.unresolvedText?.trim() ||
    !Array.isArray(entries) ||
    !entries.length ||
    entries.length > 100 ||
    entries.some(
      (item) => !item.name?.trim() || looksLikeMedicationList(item.name),
    )
  )
    return null;
  return entries;
};
